'use client';

import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { color, spacing, breakpoints } from '@/theme/tokens';
import { useTranslations } from 'next-intl';
import SectionWrapper from '@/components/common/SectionWrapper';
import styled from '@emotion/styled';
import { timelineData } from '@/components/home/Timeline/types';
import { TimelineCardComponent } from '@/components/home/Timeline/TimelineCardComponent';

// Fast Refresh ergonomics only, no runtime effect; splitting the file would churn every importer.
// react-doctor-disable-next-line only-export-components
export const GRID_CONFIG = { xs: 2, sm: 3, md: 5 };

const TimelineGrid = styled(Box)`
    display: grid;
    width: 100%;
    max-width: 100%;

    // xs: 2 columns (mobile)
    --grid-gap: ${spacing[16]};
    gap: ${spacing[16]};
    grid-template-columns: repeat(${GRID_CONFIG.xs}, 1fr);
    margin-top: ${spacing[48]} !important;

    // sm: 3 columns
    @media (min-width: ${breakpoints.sm}) {
        --grid-gap: ${spacing[64]};  // column gap value
        gap: ${spacing[32]} ${spacing[64]};
        grid-template-columns: repeat(${GRID_CONFIG.sm}, 1fr);
        margin-top: ${spacing[64]} !important;
    }

    // md: 5 columns (desktop)
    @media (min-width: ${breakpoints.md}) {
        --grid-gap: ${spacing[64]};  // column gap value
        gap: ${spacing[40]} ${spacing[64]};
        grid-template-columns: repeat(${GRID_CONFIG.md}, 1fr);
        margin-top: ${spacing[80]} !important;
    }
`;

export default function Timeline() {
    const t = useTranslations('HomePage.timeline');

    return (
        <SectionWrapper
            backgroundColor={color.gray[10]}
            contentAlignItems="center"
            contentJustifyContent="center"
        >
            <Box sx={{ paddingBottom: spacing[16] }}>
                <Stack
                    spacing={{ xs: spacing[32], sm: spacing[48], md: spacing[64] }}
                    alignItems="center"
                    width="100%"
                >
                    <Typography
                        variant="heading5bold"
                        color={color.gray[80]}
                        textAlign="center"
                        component="h2"
                        sx={{
                            maxWidth: { xs: '240px', sm: '400px', md: '460px' },
                        }}
                    >
                        {t('title')}
                    </Typography>

                    <TimelineGrid>
                        {timelineData.map((item, index) => (
                            <TimelineCardComponent
                                key={item.id}
                                item={item}
                                index={index}
                                totalItems={timelineData.length}
                            />
                        ))}
                    </TimelineGrid>
                </Stack>
            </Box>
        </SectionWrapper>
    );
}
